import React, {useState, useEffect} from 'react';
import '../../../css/pages/accountsettings.scss';
import { useHistory, useParams } from 'react-router-dom';
import APICall from '../../actions/apicall';
import Cookies from 'js-cookie';

function AccountSettings() {
    const history = useHistory();
    const [fullName, setFullName] = useState('-');
    const [emailAddress, setEmailAddress] = useState('-');
    const [phoneNumber, setPhoneNumber] = useState('-');
    const [address, setAddress] = useState('-');
    const [company, setCompany] = useState('-');
    const [title, setTitle] = useState('-');
    const [showLikedBusiness, setshowLikedBusiness] = useState(false)

    let accessToken = Cookies.get('access_token') ?? null;
    let userId = Cookies.get('rs11_user_id') ?? 0;

    if (accessToken == null){
        history.push('/map')
    }
    else {
        const token_expires_in = Cookies.get('token_expires_in');
        var time = new Date();
        const current_time = time.toISOString();
        if (current_time > token_expires_in) {
            Cookies.remove('access_token');
            Cookies.remove('token_expires_in');
            Cookies.remove('username');
            history.push('/map')
        }
    }

    const editAccountSettings = () => {
        history.push('/account-settings-edit');
    }

    useEffect (() => {
        APICall.GetAccountDetails(accessToken, (response) => {
            if (response.status == 200 && response.data.status == 'success') {
                (response.data.data.email) && setEmailAddress(response.data.data.email);
                (response.data.data.fullname) && setFullName(response.data.data.fullname);
                (response.data.data.phone_number) && setPhoneNumber(response.data.data.country_code + ' ' + response.data.data.phone_number);
                (response.data.data.company) && setCompany(response.data.data.company);
                (response.data.data.tile) && setTitle(response.data.data.tile);
                (response.data.data.address) && setAddress(response.data.data.address);
            }

        });
    }, []);

    return (
        <div className='account-settings'>
            <p className='edit-button' onClick={editAccountSettings}>Edit</p>
            <p className='title-text'>Account Settings</p>
            <div className='name-data' >
                <p className='name-text'>{fullName}</p>
                <p className='mail-text'>{emailAddress}</p>
            </div>
            <div className='account-details'>
                <div className='other-details'>
                    <p className='refer-text'>Phone Number</p>
                    <p className='details-text'>{phoneNumber}</p>
                </div>
                <div className='other-details'>
                    <p className='refer-text'>Address</p>
                    <p className='details-text'>{address}</p>
                </div>
                <div className='user-data'>
                    <div className='other-details'>
                        <p className='refer-text'>Company Represented</p>
                        <p className='details-text'>{company}</p>
                    </div>
                    <div className='other-details'>
                        <p className='refer-text'>Title</p>
                        <p className='details-text'>{title}</p>
                    </div>
                </div>
            </div>
            <div className='liked-business' onClick={() => history.push('/like')}>
                <p className='liked-text'>Liked Businesses</p>
                <p className='liked-arrow'></p>
            </div>
        </div>
    )
    
}
export default AccountSettings;